export const currency = new Intl.NumberFormat("es-CL", {
  style: "currency",
  currency: "CLP",
  maximumFractionDigits: 0,
});

export const compactNumber = new Intl.NumberFormat("es-CL", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export function pacingLabel(status: string | null, value: number): string {
  if (status === "OVER") return "OVER";
  if (status === "AT_RISK") return "EN RIESGO";
  return value >= 1 ? "OVER" : value > 0.85 ? "EN RIESGO" : "EN RANGO";
}

export function platformUrl(platform: string | null, accountId: string | null): string | null {
  if (!platform || !accountId) return null;
  const id = accountId.replaceAll("-", "");
  const normalized = platform.toLowerCase();
  if (normalized === "gads") return `https://ads.google.com/aw/overview?ocid=${id}`;
  if (normalized === "meta") return `https://adsmanager.facebook.com/adsmanager/manage/campaigns?act=${id}`;
  if (normalized === "tiktok") return "https://ads.tiktok.com/i18n/perf/campaign";
  if (normalized === "pinterest") return "https://ads.pinterest.com/";
  if (normalized === "linkedin") return id ? `https://www.linkedin.com/campaignmanager/accounts/${id}` : "https://www.linkedin.com/campaignmanager/accounts";
  return null;
}
